import { Component, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { FrontendField } from '../../netgen/FrontendField';
import { FrontendFieldGuiHint } from '../../models/frontend-field-gui-hint.model';
import { FrontendFieldType } from '../../netgen/FrontendFieldType';
import { SmFormFieldInternalComponent } from '../sm-form-field-internal/sm-form-field-internal.component';
import { FrontendForm } from '../../netgen/FrontendForm';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
    selector: 'sm-form-field',
    templateUrl: './sm-form-field.component.html',
    styleUrls: ['./sm-form-field.component.scss'],
    standalone: false
})
export class SmFormFieldComponent {

    _FrontendFieldType = FrontendFieldType;
    _Utils = Utils;

    f: FrontendField;
    fixedPos = false;

    @Input()
    form: FrontendForm;
    @Input()
    field: FrontendField = null;
    @Input()
    multipleFields: FrontendField[] = null;
    @Input()
    stackLabels = true;
    @Input()
    mandatoryFieldsRedAsterisk = false;
    @Input()
    fullHeight = false;

    @Output()
    onClick = new EventEmitter<FrontendField>();

    @ViewChild("componentInternal") componentInternal: SmFormFieldInternalComponent;

    ngDoCheck(_): void {
        this.f = this.field != null ? this.field : this.multipleFields != null ? this.multipleFields[0] : null;
        this.fixedPos = this.f?.isFixedPosition();
    }

    focus(): void {
        this.componentInternal.focus();
    }

    thisComponentAsTableEditorInited(): void {
        this.componentInternal.thisComponentAsTableEditorInited();
    }

    clickGuiHint(hint: FrontendFieldGuiHint): void {
        if (hint.onClick != null) {
            hint.onClick();
        }
    }
}
